import { createFileRoute } from '@tanstack/react-router'

import { DepartmentMembersPage } from '@/features/user-management/DepartmentMembersPage'

export const Route = createFileRoute('/_authenticated/user-mgt/staff-members')({
  component: DepartmentMembersPage,
})
